import { UrlMatchResult, UrlSegment } from '@angular/router';

const SINGLE_SEGMENT_STOREFRONT_PAGES = new Set([
  'products',
  'collections',
  'cart',
  'checkout',
  'contact',
  'blogs',
  'search',
  'password'
]);

export function publicStoreRouteMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  if (segments[0]?.path !== 'store' || !segments[1]?.path) return null;

  if (segments.length === 2) {
    return {
      consumed: segments,
      posParams: { slug: segments[1] }
    };
  }

  const section = segments[2]?.path;
  if (section && SINGLE_SEGMENT_STOREFRONT_PAGES.has(section) && segments.length === 3) {
    return {
      consumed: segments,
      posParams: {
        slug: segments[1],
        publicStorePage: segments[2]
      }
    };
  }

  if (section === 'product' && segments[3]?.path && segments.length === 4) {
    return {
      consumed: segments,
      posParams: {
        slug: segments[1],
        publicStorePage: segments[2],
        productSlug: segments[3]
      }
    };
  }

  if (section === 'collections' && segments[3]?.path && segments.length === 4) {
    return {
      consumed: segments,
      posParams: {
        slug: segments[1],
        publicStorePage: segments[2],
        collectionSlug: segments[3]
      }
    };
  }

  return null;
}
